module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"viewAuditLogs":"View audit logs","legend":"Legend:","deleted":"value deleted","added":"value added","close":"Close"},"de":{"viewAuditLogs":"Protokolle anzeigen","legend":"Legende:","deleted":"Wert gelöscht","added":"Wert hinzugefügt","close":"Schließen"}}')
  delete Component.options._Ctor
}
